import { FC, HTMLAttributes } from 'react';

import { Flex, Typography } from 'antd';

import { IAdspace } from 'entities/Adspace';

const { Text } = Typography;
interface IAdspaceNameProps extends HTMLAttributes<HTMLDivElement> {
	adspace: Partial<IAdspace>;
}

export const AdspaceName: FC<IAdspaceNameProps> = ({ adspace, ...props }) => {
	return (
		<Flex {...props} vertical>
			<Text ellipsis={{ tooltip: adspace.name }} style={{ maxWidth: 230 }}>
				{adspace.name}
			</Text>

			<Text type="secondary" copyable style={{ fontSize: 11 }}>
				{adspace.adspace_id}
			</Text>
		</Flex>
	);
};
